<!--
 * @Author: ken yang
 * @Date: 2022-08-18 14:01:38
 * @LastEditTime: 2025-07-15 14:58:07
 * @LastEditors: huguochi@mail.com zheng@sense.sg
 * @Description: 上传图片
 * @FilePath: /nicee-h5/src/components-new/uploader/index.vue
-->
<template>
  <div class="uploader">
    <div v-if="value" >
      <i class="iconfont icon-cha delete" @click="del"></i>
      <img class="thumbnail" :src="value" @click="view"/>
    </div>

    <div v-else @click="upload" class="uploader-box">
      <slot name="icon">
        <i class="iconfont icon-xiangji font-24 xiangji"></i>
      </slot>
    </div>
    <van-popup v-model="show">
      <img class="view" :src="value" />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'uploader',
  data () {
    return {
      show: false,
      // imgUrl: 'https://resource.funplus.social/user-static/f9a3d34a-1e65-4535-8ad5-5d2f38b5ccc83474317732965100229.jpg'
    };
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: Object,
      default() {
        return { width: 16, height: 9 }
      }
    }
  },
  methods: {
    upload() {
      if(this.disabled) {
        return;
      }
      this.$util.nativePie('SELECT_PHOTO', this.ratio)
        .then(({ imgUrl }) => {
          console.log('imgUrl', imgUrl);
          this.$emit('input', imgUrl)
        })
        .catch(({ msg }) => {
          this.$toast(msg)
        })
    },
    view() {
      this.show = true
    },
    del() {
      if(this.disabled) {
        return;
      }
      this.$emit('input', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.uploader{
  position: relative;
  .delete{
    position: absolute;
    top: 2px;
    right: 2px;
    color: #dcdee0;
    padding: 3px;
    font-size: 34px;
  }
}
.thumbnail{
  width: 160px;
  height: 160px;
}
.uploader-box{
  width: 160px;
  height: 160px;
  background: #f7f8fa;
  display: flex;
  justify-content: center;
  align-items: center;
  .xiangji{
    color: #dcdee0;
    font-size: 54px;
  }
}
.view{
  max-width: 500px;
}
</style>
